export default "/images/vendor/flag-icon-css/flags/1x1/gi.svg?e73af10429f00dc293ea3230387af7b6";